<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';

defineProps({
  sections: { type: Array, default: () => [] },
});

const emit = defineEmits(['action']);

const openAction = action => {
  if (action.disabled) return;

  if (action.href) {
    emit('action', action.key || action.type || 'open', action);
    window.open(action.href, '_blank', 'noopener');
    return;
  }

  if (action.emit) {
    emit('action', action.emit, action);
  }
};
</script>

<template>
  <div class="grid gap-4">
    <LaisCard
      v-for="section in sections"
      :key="section.key"
      :title="section.title"
      :prefix-icon="section.icon"
    >
      <p
        v-if="section.subtitle"
        class="mb-4 text-[13px] leading-relaxed text-lais-text-body"
      >
        {{ section.subtitle }}
      </p>

      <dl v-if="section.rows?.length" class="grid gap-3">
        <div
          v-for="row in section.rows"
          :key="`${section.key}-${row.label}`"
          class="grid gap-0.5 border-b border-lais-border-soft pb-3 last:border-b-0 last:pb-0 sm:grid-cols-[144px_1fr] sm:gap-4"
        >
          <dt class="text-[12px] font-semibold text-lais-text-muted">
            {{ row.label }}
          </dt>
          <dd class="min-w-0 text-[14px] leading-relaxed text-lais-text">
            <span class="break-words">{{ row.value }}</span>
          </dd>
        </div>
      </dl>

      <div v-if="section.metricRows?.length" class="grid gap-2 sm:grid-cols-3">
        <div
          v-for="metric in section.metricRows"
          :key="`${section.key}-${metric.label}`"
          class="rounded-lais-sm border border-lais-border-soft bg-lais-bg-soft px-3 py-3"
        >
          <strong class="block text-[24px] leading-none text-lais-text">
            {{ metric.value }}
          </strong>
          <span class="mt-1 block text-[12px] leading-snug text-lais-text-body">
            {{ metric.label }}
          </span>
        </div>
      </div>

      <div
        v-if="section.actions?.length"
        class="mt-4 grid gap-2 sm:grid-cols-2"
      >
        <button
          v-for="action in section.actions"
          :key="`${section.key}-${action.key}`"
          type="button"
          :disabled="action.disabled"
          class="inline-flex items-center justify-center gap-2 rounded-lais border border-lais-border bg-white px-3 py-2 text-[13px] font-semibold text-lais-text transition hover:border-lais-primary hover:bg-lais-primary-50/30 disabled:cursor-not-allowed disabled:opacity-50"
          @click="openAction(action)"
        >
          <span
            v-if="action.icon"
            class="size-3.5 shrink-0"
            :class="action.icon"
            aria-hidden="true"
          />
          <span>{{ action.label }}</span>
        </button>
      </div>
    </LaisCard>
  </div>
</template>
